<div dir="rtl" class="app-wrapper">
    <app-header [isRequestLayout]="true"></app-header>
    <div class="row no-gutters min-height-content">
        <div class="col-12">
            <router-outlet></router-outlet>
        </div>
    </div>
    <app-footer></app-footer>
</div>